function required(name: "VITE_API_BASE_URL") {
  const value = import.meta.env[name] as string | undefined;
  if (!value || (value !== "/" && value.includes("example.com"))) {
    throw new Error(`La variable ${name} doit être définie avant la compilation.`);
  }
  return value === "/" ? "" : value.replace(/\/$/, "");
}

export const env = {
  apiBaseUrl: required("VITE_API_BASE_URL"),
};
